import { Alert, Progress } from '@commenda/kakashi';
import { classNames } from 'node_modules/@commenda/utils';

export const ProgressTrackerRightSidebar = ({
  progress,
  sharedOn,
  service,
}: {
  progress: number;
  sharedOn: string;
  service: string | null;
}) => {
  return (
    <div className="flex flex-col gap-3xl max-w-[349px] w-full">
      <Alert
        variant="info"
        description="Secure information requests are used to collect sensitive information. Your information is securely encrypted before submission."
      />
      <div className="p-xl flex flex-col gap-xl rounded-xl border">
        <div className="flex items-center gap-xs [&>span]:w-[120px]">
          <span className="txt-small-regular text-text-tertiary">Progress</span>
          <div className="flex items-center gap-2.5 flex-1">
            <span
              className={classNames(
                'txt-small-bold',
                progress === 100 ? 'text-text-success' : 'text-text-disabled'
              )}
            >
              {progress}%
            </span>
            <Progress
              value={progress}
              accent="success"
              className="w-full rounded"
            />
          </div>
        </div>
        <div className="flex items-center gap-xs [&>span]:w-[120px]">
          <span className="txt-small-regular text-text-tertiary">
            Shared on
          </span>
          <div className="flex items-center gap-2.5">
            <span className="txt-small-medium">{sharedOn}</span>
          </div>
        </div>
        {service && (
          <div className="flex items-center gap-xs [&>span]:w-[120px]">
            <span className="txt-small-regular text-text-tertiary">
              Service
            </span>
            <div className="flex items-center gap-2.5">
              <span className="txt-small-medium">{service}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
